// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pi-spin[data-v-0112e0d1] {\n  opacity: 0.65;\n  font-size: var(--0112e0d1-iconSize) !important;\n}\n.loading-container[data-v-0112e0d1] {\n  min-height: var(--0112e0d1-minHeight);\n}", ""]);
// Exports
module.exports = exports;
